import React, { useEffect, useState } from "react";
import { useKeycloak } from "@react-keycloak/web";
import { useTranslation } from "react-i18next";
import tailwindClassnames from "./TailwindClassnames";
import { clearAuthenticatedUserContext } from "../../appInsights";
import { clearLocalStorageOnSignOut } from "../upload/interruptedUpload";

const UnauthorizedComponent = () => {
  const { keycloak } = useKeycloak();
  const [unauthorizedMessage, setUnauthorizedMessage] = useState<string | null>(
    null,
  );

  async function logoutUser() {
    clearAuthenticatedUserContext();
    // Everything but a message left for an account whose upload a dead session cut short
    // (AKL-891); see interruptedUpload.ts.
    clearLocalStorageOnSignOut();
    keycloak.logout({
      redirectUri: window.location.origin + "/login",
    });
  }

  useEffect(() => {
    // I dont love this approach but we cant use context in axios interceptor
    // or an event emitter, so this is best I can think of at the moment
    const message = localStorage.getItem("unauthorizedMessage");
    if (message) {
      setUnauthorizedMessage(message);
      localStorage.removeItem("unauthorizedMessage");
    }
  }, []);

  const { t } = useTranslation();

  return (
    <div className="flex justify-center h-screen">
      <div className="mt-6 mx-2">
        <div className="px-4 pt-4 pb-2 bg-dustyGray-300 dark:bg-dustyGray-800">
          {unauthorizedMessage ? (
            <p className={tailwindClassnames.warningHeader}>
              {unauthorizedMessage}
              <br />
              <br />
            </p>
          ) : (
            <p className={tailwindClassnames.warningHeader}>
              {t("UnauthorizedPart1")}
              <br />
            </p>
          )}
          <p className={`mt-6 ${tailwindClassnames.basicLabel}`}>
            {t("UnauthorizedPart2")}
          </p>
          <p className={tailwindClassnames.basicLabel}>
            {t("UnauthorizedPart3")}
          </p>
          <div className="bg-dustyGray-300 dark:bg-dustyGray-800 mt-2 flex justify-center">
            <button
              type="button"
              className={tailwindClassnames.saveButton}
              onClick={logoutUser}
            >
              {t("Okay")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedComponent;
